<template>
  <div class="streaks--dropdown">
    <div class="streaks--count">
      <div class="streaks--flame">
        🔥
        <!-- <IconBase icon-name="hot" iconColor="" viewBox="0 0 256 256" width="100%" height="100%" strokeWidth="1px" :scale="1"><IconFlame /></IconBase> -->
      </div>
      <!-- <ik-image loading="lazy" :transformation="[{ height: 200, width: 200 }]" src="https://ik.imagekit.io/elysiumone/Official/flames__2__Ezn5wNIJ4.png?ik-sdk-version=javascript-1.4.3&updatedAt=1661412361236" class="streaks--flame" /> -->
      <div class="streaks--number">{{ getStreakNumber }}</div>
    </div>
    <div class="streaks--overview" v-if="last7Days && last7Days.length">
      <div class="streaks--overview-header">
        <div class="streaks--count">
          <div class="streaks--overview-flame">
            🔥
            <!-- <IconBase icon-name="hot" iconColor="" viewBox="0 0 256 256" width="100%" height="100%" strokeWidth="0px" :scale="1"><IconFlame /></IconBase> -->
          </div>
          <!-- <ik-image loading="lazy" :transformation="[{ height: 200, width: 200 }]" src="https://ik.imagekit.io/elysiumone/Official/flames__2__Ezn5wNIJ4.png?ik-sdk-version=javascript-1.4.3&updatedAt=1661412361236" class="streaks--flame" /> -->
          <div class="streaks--overview-number">{{ getStreakNumber }}</div>
        </div>
        <div class="streaks--overview-text">Do a session every day to build a streak!</div>
      </div>
      <div class="streaks--overview-days">
        <div class="streaks--overview-day" v-for="(day, index) in last7Days" :key="index">
          <div class="streaks--overview-dayOfWeek">{{ getDay(day) }}</div>
          <div class="streaks--check" @click="toggleComplete" :class="didSessionThatDay(day) ? 'streaks--check-complete' : ''">
            <div class="streaks--check-icon">
              <IconBase icon-name="check" iconColor="#fff" viewBox="0 0 512.008 512.008" width="100%" height="100%" strokeWidth="10px" :scale="1"><IconCheckmark /></IconBase>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { startOfDay, subDays, format, isSameDay } from "date-fns";
import IconBase from "../../../components/IconBase.vue";
/* import IconHot from "../../../components/SVG/IconHot.vue"; */
/* import IconFlame from "../../../components/SVG/IconFlame.vue"; */
import IconCheckmark from "../../../components/SVG/IconCheckmark.vue";

export default {
  name: "StreakDropdown",
  components: {
    IconBase,
    /* IconHot, */
    /* IconFlame, */
    IconCheckmark,
  },
  created() {
    this.constructLast7Days();
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      userstats: (state) => state.userstats,
    }),
    getStreakNumber() {
      const stats = this.userstats;
      if (!stats || !stats.counters || !stats.counters.dayStreak) {
        return 0;
      }
      if (stats.counters.dayStreak > 0) {
        /* If last session is not today, then it is an older streak START, then return 0, otherwise if today, return 1 */
        const lastSession = stats.counters.last7Days[stats.counters.last7Days.length - 1];
        const todayMS = Date.now();
        const startOfTodayMS = startOfDay(todayMS);
        const yesterdayMS = subDays(startOfTodayMS, 1);
        const lastSessionDateMS = lastSession.dateMS;
        const lastSessionDayIsToday = isSameDay(lastSessionDateMS, todayMS);
        const lastSessionDayIsYesterday = isSameDay(lastSessionDateMS, yesterdayMS);
        if (lastSessionDayIsToday || lastSessionDayIsYesterday) return stats.counters.dayStreak;
        else return 0;
      }
      return "teehee";
    },
  },
  data() {
    return {
      last7Days: [],
    };
  },
  methods: {
    toggleComplete() {
      console.log("Test");
    },
    constructLast7Days() {
      const today = new Date();
      const startOfToday = startOfDay(today);
      this.last7Days.push(startOfToday);
      let prevDate = null;
      for (var i = 0; i < 6; i++) {
        if (!prevDate) prevDate = subDays(startOfToday, 1);
        else prevDate = subDays(prevDate, 1);
        this.last7Days.push(prevDate);
      }
      this.last7Days = this.last7Days.reverse();
    },
    didSessionThatDay(day) {
      const stats = this.userstats;
      if (!stats || !stats.counters || !stats.counters.last7Days || !stats.counters.last7Days.length) {
        return false;
      }

      for (var i = 0; i < stats.counters.last7Days.length; i++) {
        const sessionDateMS = stats.counters.last7Days[i].dateMS;
        
        const startOfSessionDay = startOfDay(sessionDateMS);
        if (startOfSessionDay.valueOf() === day.valueOf()) return true;
      }
      return false;
    },
    getDay(day) {
      return format(day, "ccc");
    },
  },
};
</script>

<style scoped>
@import "./styles/Dropdown.css";

.streaks--dropdown {
  /* NEW */
  position: relative;
  /*   display: flex;
  -webkit-backdrop-filter: blur(5px);
  padding: 4px 8px;
  border-radius: 360px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(5px);
  box-shadow: 0px 1px 4px 0 #afafaf57;
  background-color: #ffffffba !important; */
}
/* .streaks--dropdown:hover > .streaks--overview {
  display: block;
} */
.streaks--overview {
  position: absolute;
  width: 300px;
  z-index: 9999;
  border-radius: 12px;
  top: 41px;
  left: calc((-300px + 62.5px) / 2);
  padding: 4px 0px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: white;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  display: none;
}
.streaks--overview-header {
  padding: 15px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.streaks--overview-icon {
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 18px;
  box-sizing: border-box;
  text-align: center;
  margin-right: 5px;
}
.streaks--overview-text {
  width: 180px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  box-sizing: border-box;
  font-weight: 600;
  margin-left: 5px;
  padding-top: 5px;
}
.streaks--overview-days {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding: 10px;
}
.streaks--overview-day {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 20px;
}
.streaks--overview-dayOfWeek {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 4px;
}
.streaks--overview-completion {
  border: 1px solid;
  width: 20px;
  height: 20px;
  border-radius: 360px;
}
.streaks--check {
  border-radius: 360px;
  width: 24px;
  height: 24px;
  color: #a7a7a7ba;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
  flex-shrink: 0;
  background-color: #e3e3e3;
}

.streaks--check-complete {
  /* background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%); */
  background: linear-gradient(to top, #ffcc00 0%, #ff9000 50%, #ff1300 100%);
  background-blend-mode: multiply, multiply;
  /* box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%); */
}
.streaks--check-icon {
  color: white;
  width: 12px;
  height: 12px;
}
.streaks--count {
  border-radius: 12px;
  padding: 6px 10px;
  padding-bottom: 2px;
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}
.streaks--count:hover {
  opacity: 0.8;
}
.streaks--flame {
  width: 18px;
  height: 18px;
  margin-right: 3px;
  mix-blend-mode: luminosity;
}
.streaks--number {
  font-weight: 600;
  font-size: 14.5px;
  padding-bottom: 3px;
  color: #282828;
}
.streaks--overview-flame {
  width: 18px;
  height: 18px;
  mix-blend-mode: darken;
  position: absolute;
  font-size: 46px;
  left: -2px;
  top: -14px;
}
.streaks--overview-number {
  position: absolute;
  color: black;
  font-size: 14.5px;
  box-sizing: border-box;
  width: 42px;
  height: 42px;
  top: 2px;
  font-weight: 700;
  left: 0px;
  border-radius: 360px;
  padding: 5px;
  background-color: #ffffff59;
  text-align: center;
}
</style>
